import { motion } from "framer-motion";

export const EYBLogo = ({ size = 64, floating = true }) => {
  return (
    <motion.img
      data-testid="eyb-logo"
      src="/eyb-logo.png"
      alt="EYB Consulting"
      animate={floating ? { y: [0, -6, 0] } : undefined}
      transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
      className="shrink-0 object-contain"
      style={{
        width: size,
        height: size,
        filter: "drop-shadow(0 12px 24px rgba(3,20,45,0.45))",
      }}
    />
  );
};
